import { render, staticRenderFns } from "./CourseSelection.vue?vue&type=template&id=0a6694a8&scoped=true"
import script from "./CourseSelection.vue?vue&type=script&lang=js"
export * from "./CourseSelection.vue?vue&type=script&lang=js"
import style0 from "./CourseSelection.vue?vue&type=style&index=0&id=0a6694a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6694a8",
  null
  
)

export default component.exports